import React from "react";
import PropTypes from "prop-types";
import styles from "./RectangleEdit.module.scss";

const RectangleEdit = (props) => {
  return (
    <button
      type="button"
      className={styles.Edit}
      onClick={props.onEditClick}
      data-testid={props.dataTestId}
    >
      <div className={styles.RectangleStart} />
      <div className={styles.RectangleEnd} />
    </button>
  );
};

RectangleEdit.propTypes = {
  dataTestId: PropTypes.string,
  onEditClick: PropTypes.func,
};

export default RectangleEdit;
